// 钉钉环境工具:以 UA 判断替代 dingtalk-jsapi 依赖。
// 与 JSAPI 内部实现一致(env.js 里 platform 判定即 /DingTalk/i.test(userAgent))。
// dd.quitPage 是真实 JSBridge 调用,仅在钉钉容器内按需加载 CDN 版 JSAPI 调用。
const DINGTALK_JSAPI_CDN = 'https://g.alicdn.com/dingding/dingtalk-jsapi/2.10.3/dingtalk.open.js'

let jsapiPromise = null

function loadJsapi() {
    if (jsapiPromise) {
        return jsapiPromise
    }
    jsapiPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = DINGTALK_JSAPI_CDN
        script.onload = () => resolve(window.dd)
        script.onerror = () => {
            jsapiPromise = null
            reject(new Error('钉钉JSAPI加载失败'))
        }
        document.head.appendChild(script)
    })
    return jsapiPromise
}

export function isDingTalk() {
    return /DingTalk/i.test(navigator.userAgent)
}

// 钉钉容器内关闭当前页面;非钉钉环境或 JSAPI 加载失败时静默降级
export function quitPage() {
    if (!isDingTalk()) {
        return
    }
    loadJsapi()
        .then(dd => {
            if (dd && typeof dd.quitPage === 'function') {
                dd.quitPage({
                    success: () => {},
                    fail: () => {},
                    complete: () => {},
                })
            }
        })
        .catch(() => {})
}